<template>

</template>

<script>

  import {mapActions} from 'vuex'
  import BaseComponent from '../scenarios/BaseComponent'

  const AUTH_API = '/api/auth'

  export default {
    name: 'AuthCommon',

    extends: BaseComponent,
    methods: {
      ...mapActions([
        'setAuthenticationToken',
        'setLoggedRole',
        'setLoggedStatus',
        'setLoggedId',
        'setLoggedUser',
        'setLoggedUserState',
        'setPermissionMap',
        'setClientId'
      ]),
      loginCallback(response) {
        this.setAuthenticationToken(response.data.auth.token)
        this.setLoggedRole(response.data.role)
        this.setLoggedId(response.data.id)
        this.setLoggedUser(response.data.username)
        this.setLoggedUserState(response.data.state)
        this.setLoggedStatus(true)
        this.setPermission(response.data.role)
        this.setClientId(response.data.clientid)
      },
      setPermission(role) {
        this.$http.get(AUTH_API + '/getPermissions/' + role, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            var pMap = JSON.stringify(Object.entries(response.data))
            this.setPermissionMap(pMap)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка установки разрешений. ')
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AuthCommon.vue?15af2f14